<template>
    <div class="content_box mobile_content">
        <div class="content role">
            <div class="title_box">
                <span class="title">广告配置</span>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-input placeholder="请输入名称" clearable :disabled="isSort" v-model="searchData.name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.banner_type" clearable :disabled="isSort" placeholder="类型">
                            <el-option label="Banner" value="scrolling"></el-option>
                            <el-option label="开屏海报" value="launch"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.state" :disabled="isSort" placeholder="状态">
                            <el-option label="使用中" value="2"></el-option>
                            <el-option label="已过期" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <div class="button button2 add" @click="addRole" v-if="roleCheck('103-102-101-102')">
                    <i class="el-icon-plus"></i>
                    <span>新建</span>
                </div>
                <div class="sort_box">
                    <div class="button sort" @click="enterSortMode" v-if="roleCheck('103-102-101-102') && !isSort">
                        <span>排序</span>
                    </div>
                    <template v-if="isSort">
                        <div class="button sort save" @click="saveSort">
                            <span>保存排序</span>
                        </div>
                        <div class="button sort back" @click="exitSortMode">
                            <span>取消</span>
                        </div>
                    </template>
                </div>
            </div>

            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%"
                row-key="id">
                <el-table-column prop="id" label="ID"  width="100px"></el-table-column>
                <el-table-column label="类型"  width="100px">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.banner_type == 'scrolling'">Banner</span>
                        <span v-if="scope.row.banner_type == 'launch'">开屏海报</span>
                    </template>
                </el-table-column>
                <el-table-column prop="banner_name" show-overflow-tooltip label="名称"></el-table-column>
                <el-table-column label="图片" width="140px">
                    <template slot-scope="scope" >
                        <img class="banner_img" :src="scope.row.banner_url" alt="">
                    </template>
                </el-table-column>
                <el-table-column label="生效时间" width="150px">
                    <template slot-scope="scope" >
                        <span>{{formDate(scope.row.start_time, 'YYYY-MM-DD HH:mm') + '~' + formDate(scope.row.end_time, 'YYYY-MM-DD HH:mm')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="jump_url" show-overflow-tooltip label="链接"></el-table-column>
                <el-table-column label="状态" width="80px">
                    <template slot-scope="scope" >
                        <span class="state state2" v-if="scope.row.state == 2">使用中</span>
                        <span class="state state1" v-else-if="scope.row.state == 1">已过期</span>
                    </template>
                </el-table-column>
                <el-table-column label="展示规则"  width="100px">
                    <template slot-scope="scope" >
                        <span>{{ scope.row.banner_type == 'launch' ? (scope.row.rule_type == 'every_one' ? '每天一次' : '每次') : '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="group_name" label="群组">
                    <template slot-scope="scope" >
                        <span>{{scope.row.group_name.join('；')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope" >
                        <div v-if="!isSort">
                            <div class="button text" @click="dislogShow(scope.row)" v-if="roleCheck('103-102-101-102')">编辑</div>
                            <div class="button text del_btn" @click="delList(scope.row.id)" v-if="roleCheck('103-102-101-104')">删除</div>
                        </div>
                        <div v-else-if="scope.row.state != 1" class="drag-handle" title="拖拽排序">
                            <span>⋮⋮</span>
                        </div>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            <Tip ref="tip" msg="确定删除该内容？" @tipBack="delConfirm"></Tip>
            <Gh-Dialog ref="dislog" size="big" :title="dislog.title" @dialogBack="updateConfirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData" ref="formRule" :rules="formRule">
                        <el-form-item label="类型" prop="type">
                            <el-select v-model="actData.banner_type" placeholder="类型">
                                <el-option label="Banner" value="scrolling"></el-option>
                                <el-option label="开屏海报" value="launch"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="名称" prop="banner_name">
                            <el-input v-model="actData.banner_name" maxlength="100" placeholder="请输入名称"></el-input>
                        </el-form-item>
                        <el-form-item label="规则" prop="rule_type" v-if="actData.banner_type == 'launch'">
                            <el-select v-model="actData.rule_type" placeholder="规则">
                                <el-option label="每天一次" value="every_one"></el-option>
                                <el-option label="每次" value="every_time"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="标题">
                            <el-input v-model="actData.banner_title" maxlength="100" placeholder="请输入标题"></el-input>
                        </el-form-item>
                        <el-form-item label="图片" prop="banner_pic">
                            <el-upload
                                class="upload_box"
                                action=""
                                :http-request="uploadFile"
                                :show-file-list="false"
                                accept="image/*"
                                >
                                <img v-if="imageUrl" :src="imageUrl" class="banner_img">
                                <i v-else class="el-icon-plus banner_icon"></i>
                                <div slot="tip" class="el-upload__tip">{{`（请使用${actData.banner_type == 'scrolling' ? '21:9' : '305*380'}的图片）`}}</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="生效时间" prop="start_time">
                            <el-date-picker class="datetimerange" v-model="time" :clearable="false" type="datetimerange"
                                range-separator="至" v-if="$store.state.type == 'pc'"
                                start-placeholder="开始日期" end-placeholder="结束日期"
                                :default-time="['00:00:00','23:59:59']" value-format="timestamp" format="yyyy-MM-dd HH:mm"
                                placement="bottom-start" >
                            </el-date-picker>
                            <DatePicker v-else :date="time" vanType="datetime " @dateSelect="dateSelect"></DatePicker>
                            <!-- <DatePicker :date="time" disabledDate="disabledDate" @dateSelect="dateSelect"></DatePicker> -->
                        </el-form-item>
                        <el-form-item label="跳转链接" prop="jump_url">
                            <el-input v-model="actData.jump_url" placeholder="请输入跳转链接"></el-input>
                        </el-form-item>
                        <el-form-item label="跳转方式" prop="jump_type">
                            <el-radio-group v-model="actData.jump_type">
                                <el-radio label="H5">内部H5</el-radio>
                                <el-radio label="WEB">外部浏览器</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="群组">
                            <el-select v-model="groupList" multiple placeholder="请选择群组">
                                <el-option :label="item.group_name" :value="item.id" v-for="(item, i) in group" :key="i + '43324'"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
import Sortable from 'sortablejs'
import upload from '../../../components/file/upload'
export default({
    name: 'app-banner-manage',
    data() {
        return {
            isSort: false,
            sortBtnShow: true,
            sortableInstance: null,
            originSortData: [],
            searchData: {
                state: '2',
                page_size: 10,
                page: 1
            },
            time: [],
            listData: [],
            total: 0,
            dislog: {
                type: '',
                title: ''
            },
            group: [],
            groupList: [],
            actData: {},
            delListId: '',
            imageUrl: '',
            formRule: {
                banner_name: [this.requiredRule('请输入名称')],
                banner_pic: [this.requiredRule('请选择图片')],
                start_time: [{required: true, message: '请选择生效时间', trigger: 'change', type: 'date'}],
                jump_url: [this.requiredRule('请输入跳转连接')],
                jump_type: [this.requiredRule('请选择跳转方式')],
            },
        }
    },
    components: {
        upload
    },
    watch: {
        time: function (nTime) {
            if (nTime && nTime.length > 1) {
                this.actData.start_time = nTime[0];
                this.actData.end_time = nTime[1];
            } else {
                this.actData.start_time = '';
                this.actData.end_time = '';
            }
        },
    },
    created() {
        this.getBannerList();
        this.getGroupList();
    },
    methods: {
        search(){
            this.searchData.page = 1;
            this.getBannerList();
        },
        addRole() {
            this.dislog = {
                type: 'add',
                title: '新增Banner'
            };
            this.actData = {
                banner_type: 'scrolling',
                rule_type: 'every_one',
                start_time: '',
                banner_pic: '',
                jump_type: 'H5'
            };
            this.imageUrl = '';
            this.time = [];
            this.groupList = [];
            this.$refs.dislog.show = true;
        },
        getBannerList() {
            this.api.getBannerList(this.searchData).then(data => {
                this.listData = data.data.result || [];
                this.total = data.data.total || 0;
            })
        },
        getGroupList() {
            this.api.getGroupList({}).then(data => {
                this.group = data.data.result;
            })
        },
        dislogShow(item) {
            this.dislog = {
                type: 'update',
                title: '编辑Banner'
            };
            this.actData = {
                id: item.id,
                banner_type: item.banner_type,
                rule_type: item.rule_type,
                banner_name: item.banner_name,
                banner_title: item.banner_title,
                banner_pic: item.banner_pic,
                start_time: item.start_time,
                end_time: item.end_time,
                group_list: item.group_list,
                jump_type: item.jump_type,
                jump_url: item.jump_url,
                priority: item.priority
            };
            this.time = [parseInt(item.start_time),parseInt(item.end_time)];
            this.imageUrl = item.banner_url;
            this.groupList = item.group_list ? item.group_list.split(';').map(Number) : '';
            this.$refs.dislog.show = true;
        },
        uploadFile(file) {
            /*
                上传alioss 上传展示的文件需要转成blob 创建链接展示
                上传alioss接口uploadAliOss，第一个参数为oss存储地址+文件名字，第二个参数为上传的文件
            */
            this.imageUrl = window.URL.createObjectURL(new Blob([file.file]));
            const timestamp = new Date().getTime();
            this.uploadAliOss(`op/app/banner/${this.formDate(timestamp, 'YYYYMMDD')}/${timestamp+'_'+file.file.name}`, file.file).then(data => {
                this.actData.banner_pic = decodeURIComponent((data[0].split('aliyuncs.com/')[1]).split('?')[0]);
                this.$refs.formRule.validateField('banner_pic');
            }).catch(data => {
                this.imageUrl = item.banner_url || '';
                console.log(data)
                this.$message.success('文件上传失败，请稍后重试!');
            });
        },
        dateSelect(date) {
            this.time = date ? [...date] : '';
        },
        updateConfirm() {
            this.$refs.formRule.validate(v => {
                if(v) {
                    this.actData.group_list = this.groupList.join(';');
                    this.api.updateBanner(this.actData).then(data => {
                        if(data.code == 0 || data.code == 200) {
                            this.$message.success('操作成功！');
                            this.getBannerList();
                            this.$refs.dislog.show = false;
                        }
                    })
                }
            })

        },
        enterSortMode() {
            // 备份当前排序，用于取消时恢复
            this.originSortData = JSON.parse(JSON.stringify(this.listData));
            this.isSort = true;
            this.$nextTick(() => {
                this.initSortable();
            });
        },
        exitSortMode() {
            this.isSort = false;
            // 恢复备份的原始顺序
            this.listData = this.originSortData;
            this.destroySortable();
        },
        saveSort() {
            // 根据拖拽后的顺序重新分配 priority（越靠前 priority 越大）
            let promises = [];
            this.listData.forEach((item, index) => {
                let newPriority = (this.listData.length - index) * 100;
                if (item.priority !== newPriority) {
                    promises.push(this.api.updateBanner({
                        id: item.id,
                        priority: newPriority
                    }));
                }
            });
            if (promises.length === 0) {
                this.$message.success('排序未发生变化');
                this.isSort = false;
                return;
            }
            Promise.all(promises).then(() => {
                this.$message.success('排序保存成功！');
                this.isSort = false;
                this.getBannerList();
            }).catch(() => {
                this.$message.error('排序保存失败，请重试！');
            });
        },
        initSortable() {
            const el = this.$el.querySelector('.el-table__body-wrapper tbody');
            if (!el || this.sortableInstance) return;
            this.sortableInstance = new Sortable(el, {
                animation: 150,
                handle: '.drag-handle',
                onEnd: (evt) => {
                    const { oldIndex, newIndex } = evt;
                    if (oldIndex === newIndex) return;
                    const moved = this.listData.splice(oldIndex, 1)[0];
                    this.listData.splice(newIndex, 0, moved);
                }
            });
        },
        destroySortable() {
            if (this.sortableInstance) {
                this.sortableInstance.destroy();
                this.sortableInstance = null;
            }
        },
        delList(id) {
            this.$refs.tip.show = true;
            this.delListId = id;
        },
        delConfirm() {
            this.api.delBanner({id: this.delListId}).then(data => {
                this.$message.success('删除成功！');
                this.getBannerList();
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getBannerList();
        },
    }
})
</script>
<style lang="less" scoped>
    .margin_top{
        margin-top: 10px;
    }
    .btn_box{
        .sort_box{
            display: inline-block;
            float: right;
            .sort{
                background: #E4F9F8;
                border-color: #E4F9F8;
                color: #00D6B9;
                &.save{
                    background: #E4F9F8;
                    border-color: #E4F9F8;
                    color: #00D6B9;
                }
                &.back{
                    background: #F0F5FE;
                    border-color: #5192FF;
                    color: #507FF7;
                }
            }
        }
        @media (max-width: 500px){
            .button{
                width: 80px;
            }
        }
    }
    .state{
        color: #EB534B;
        &.state1{
            color: #000;
        }
        &.state2{
            color: #2A79FF;
        }
    }
    .content /deep/ .el-dialog .el-dialog__body {
        max-height: 550px;
    }
    .drag-handle {
        cursor: grab;
        color: #999;
        font-size: 18px;
        letter-spacing: 2px;
        user-select: none;
        display: inline-block;
        padding: 4px 8px;
    }
    .drag-handle:active {
        cursor: grabbing;
    }
</style>


// WEBPACK FOOTER //
// src/view/app/market-manage/banner-manage.vue